'use strict';

const SiteValues={
  ww:()=>{ var v=(window.innerWidth)?window.innerWidth:window.outerWidth; return v; },
  wh:()=>{ var v=(window.innerHeight)?window.innerHeight:window.outerHeight; return v; },
  dh:()=>{
    var v=Math.max.apply(null,[document.body.clientHeight,document.body.scrollHeight,document.documentElement.scrollHeight,document.documentElement.clientHeight]);
    return v;
  },
  st:()=>{ var v=window.scrollY; return v; },
  hh:()=>{ var v=document.querySelector('.l-hd').offsetHeight; return v; },
  ua:navigator.userAgent
};

const isMobile=()=>{ var v=(SiteValues.ww()<=749)?true:false; return v; };
const isDesktop=()=>{ var v=(SiteValues.ww()>=750)?true:false; return v; };
const isTouch=()=>{ var v=(SiteValues.ua.indexOf('iPhone')>1||SiteValues.ua.indexOf('iPad')>1||SiteValues.ua.indexOf('Android')>1)?true:false; return v; };

class fadeToggle {
  constructor($target,duration=400,delay=40){
    if(window.getComputedStyle($target).display==='none'){
      this._fadeIn($target,duration,delay);
    }else{
      this._fadeOut($target,duration,delay);
    };
  };
  _fadeOut=(el,duration,delay)=>{
    const coef=1/(duration/delay);
    el.style.opacity=1.0;
    let opacity=Number(el.style.opacity);
    const animation=setInterval(()=>{
      opacity-=coef;
      el.style.opacity=opacity;
      if(opacity<=0){
        el.style.display='none';
        clearInterval(animation);
      };
    }, delay);
  };
  _fadeIn=(el,duration,delay)=>{
    const coef=1/(duration/delay);
    el.style.display='block';
    el.style.opacity=0;
    let opacity=Number(el.style.opacity);
    const animation=setInterval(()=>{
      opacity+=coef;
      el.style.opacity=opacity;
      if(opacity>=1){
        clearInterval(animation);
      };
    },delay);
  };
};

class slideToggle {
  constructor($target,duration=400){
    if(window.getComputedStyle($target).display==='none'){
      this._slideDown($target,duration);
    }else{
      this._slideUp($target,duration);
    };
  };
  _slideUp=(el,duration)=>{
    el.style.height=el.offsetHeight+'px';
    el.offsetHeight;
    el.style.transitionProperty='height,margin,padding';
    el.style.overflow='hidden';
    el.style.height=0;
    el.style.paddingTop=0;
    el.style.paddingBottom=0;
    el.style.marginTop=0;
    el.style.marginBottom=0;
    el.style.transitionDuration=duration+'ms';
    el.style.transitionTimingFunction='ease';
    setTimeout(()=>{
      el.style.display='none';
      el.style.removeProperty('height');
      el.style.removeProperty('padding-top');
      el.style.removeProperty('padding-bottom');
      el.style.removeProperty('margin-top');
      el.style.removeProperty('margin-bottom');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
      el.style.removeProperty('transition-timing-function');
    },duration);
  };
  _slideDown=(el,duration)=>{
    el.style.removeProperty('display');
    let display=window.getComputedStyle(el).display;
    if(display==='none') display='block';
    el.style.display=display;
    let height=el.offsetHeight;
    el.style.overflow='hidden';
    el.style.height=0;
    el.style.paddingTop=0;
    el.style.paddingBottom=0;
    el.style.marginTop=0;
    el.style.marginBottom=0;
    el.offsetHeight;
    el.style.transitionProperty='height,margin,padding';
    el.style.height=height+'px';
    el.style.transitionDuration=duration+'ms';
    el.style.transitionTimingFunction='ease';
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
    setTimeout(()=>{
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
      el.style.removeProperty('transition-timing-function');
    },duration);
  };
};

class pageScroll {
  constructor($trigger,behavior='smooth'){
    document.querySelectorAll($trigger).forEach($this=>{
      $this.addEventListener('click',event=>{
        event.preventDefault();
        let hash=$this.getAttribute('href');
        hash=hash.replace(/^#([\d\D]+)/,'$1');
        let $hash=document.getElementById(hash);
        if($hash){
          $hash.scrollIntoView({
            behavior:behavior
          });
        };
      });
    });
  };
};

// new pageScroll('a[href^="#"]','smooth');

class tabToggle {
  constructor($tab,trigger){
    this.$triggers=$tab.querySelectorAll(`.${trigger}`);
    this._tab();
  };
  _tab=()=>{
    this.$triggers.forEach($trigger=>{
      $trigger.addEventListener('click',event=>{
        event.preventDefault();
        let controls=$trigger.getAttribute('aria-controls');
        let $target=document.getElementById(controls);
        let expanded=$trigger.getAttribute('aria-expanded');
        if($target&&expanded==='false'){
          this._reset();
          $trigger.setAttribute('aria-expanded',true);
          new fadeToggle($target);
          $target.setAttribute('aria-hidden',false);
        };
      });
    });
  };
  _reset=()=>{
    this.$triggers.forEach($trigger=>{
      let controls=$trigger.getAttribute('aria-controls');
      let $target=document.getElementById(controls);
      if($target){
        $trigger.setAttribute('aria-expanded',false);
        $target.style.display='none';
        $target.setAttribute('aria-hidden',true);
      };
    });
  };
};

const $tabs1=document.querySelectorAll('.tab-1');
if($tabs1.length){
  $tabs1.forEach($tab=>{
    new tabToggle($tab,'tab-1-trigger');
  });
};

class switchLocalization {
  constructor($trigger,type){
    this.type=type;
    this.$trigger=$trigger;
    this.$form=document.getElementById('localization-switch-form');
    this.$language=this.$form.querySelector('[name=language_code]');
    this.$country=this.$form.querySelector('[name=country_code]');
    this._switch();
  };
  _switch=()=>{
    this.$trigger.addEventListener('click',event=>{
      event.preventDefault();
      let code=null;
      switch(this.type){
      case 'language' :
        code=this.$trigger.getAttribute('data-language-code');
        this.$language.value=code;
        break;
      case 'country' :
        code=this.$trigger.getAttribute('data-country-code');
        this.$country.value=code;
        break;
      };
      if(code){
        this.$form.submit();
      };
    });
  };
};

const $dataLanguageCodes=document.querySelectorAll('[data-language-code]');
if($dataLanguageCodes.length){
  $dataLanguageCodes.forEach($code=>{
    new switchLocalization($code,'language');
  });
};

const $dataCountryCodes=document.querySelectorAll('[data-country-code]');
if($dataCountryCodes.length){
  $dataCountryCodes.forEach($code=>{
    new switchLocalization($code,'country');
  });
};

class layoutHeader {
  constructor(prefix){
    this.prefix=prefix;
    this.$body=document.body;
    this.$t=document.querySelector(`.${this.prefix}`);
    this.$nav=this.$t.querySelector(`.${this.prefix}-nav`);
    this.$menu=this.$t.querySelector(`.${this.prefix}-menu`);
    this.$switchs=this.$t.querySelectorAll(`.${this.prefix}-switch`);
    this.$gnav=this.$t.querySelector('.l-gnav');
    this.$gnavSwitchs=this.$gnav.querySelectorAll('.l-gnav-switch');
    this.$sectionVisual=document.querySelector('.s-visual');

    this._navigation();
    this._switch();
    this._globalNavigation();
    if(this.$sectionVisual){
      this._scrollFixed();
      window.addEventListener('scroll',this._scrollFixed);
    };
  };
  _navigation=()=>{
    let $items=this.$nav.querySelectorAll(`.${this.prefix}-nav__lists__item`);
    $items.forEach($item=>{
      let $button=$item.querySelector(':scope > button');
      if($button){
        let controls=$button.getAttribute('aria-controls');
        let $target=document.getElementById(controls);
        if($target){
          if(isTouch()){
            $item.addEventListener('click',event=>{
              event.preventDefault();
              let isExpanded=$button.getAttribute('aria-expanded');
              let isHidden=$button.getAttribute('aria-hidden');
              if(isExpanded==='true'){
                isExpanded=false;
                isHidden=true;
              }else{
                isExpanded=true;
                isHidden=false;
              };
              $items.forEach($otherItem=>{
                let $otherButton=$otherItem.querySelector(':scope > button');
                let $otherTarget=$otherItem.querySelector(`.${this.prefix}-snav`);
                if($otherButton&&$otherTarget){
                  $otherButton.setAttribute('aria-expanded',false);
                  $otherTarget.setAttribute('aria-hidden',true);
                };
              });
              $button.setAttribute('aria-expanded',isExpanded);
              $target.setAttribute('aria-hidden',isHidden);
            });
          }else{
            let isHover=false;
            let snavToggle={
              open:()=>{
                $button.setAttribute('aria-expanded',true);
                $target.setAttribute('aria-hidden',false);
              },
              close:()=>{
                $button.setAttribute('aria-expanded',false);
                $target.setAttribute('aria-hidden',true);
              }
            };
            $button.addEventListener('mouseenter',event=>{
              isHover=false;
              snavToggle.open();
            });
            $button.addEventListener('mouseleave',event=>{
              setTimeout(()=>{
                if(!isHover) snavToggle.close();
              },100);
            });
            $target.addEventListener('mouseenter',event=>{
              isHover=true;
              snavToggle.open();
            });
            $target.addEventListener('mouseleave',event=>{
              snavToggle.close();
            });
          };
        };
      }
    });
  };
  _switch=()=>{
    if(this.$switchs.length){
      this.$switchs.forEach($switch=>{
        let $button=$switch.querySelector(`.${this.prefix}-switch__trigger`);
        if($button){
          let controls=$button.getAttribute('aria-controls');
          let $target=document.getElementById(controls);
          if($target){
            if(isTouch()){
              $button.addEventListener('click',event=>{
                event.preventDefault();
                let isExpanded=$button.getAttribute('aria-expanded');
                let isHidden=$button.getAttribute('aria-hidden');
                if(isExpanded==='true'){
                  isExpanded=false;
                  isHidden=true;
                }else{
                  isExpanded=true;
                  isHidden=false;
                };
                this.$switchs.forEach($otherSwitch=>{
                  let $otherButton=$otherSwitch.querySelector(`.${this.prefix}-switch__trigger`);
                  let otherControls=$otherButton.getAttribute('aria-controls');
                  let $otherTarget=document.getElementById(otherControls);
                  if($otherButton&&$otherTarget){
                    $otherButton.setAttribute('aria-expanded',false);
                    $otherTarget.setAttribute('aria-hidden',true);
                  };
                });
                $button.setAttribute('aria-expanded',isExpanded);
                $target.setAttribute('aria-hidden',isHidden);
              });
            }else{
              let isHover=false;
              let switchToggle={
                open:()=>{
                  $button.setAttribute('aria-expanded',true);
                  $target.setAttribute('aria-hidden',false);
                },
                close:()=>{
                  $button.setAttribute('aria-expanded',false);
                  $target.setAttribute('aria-hidden',true);
                }
              };
              $button.addEventListener('mouseenter',event=>{
                isHover=false;
                switchToggle.open();
              });
              $button.addEventListener('mouseleave',event=>{
                setTimeout(()=>{
                  if(!isHover) switchToggle.close();
                },100);
              });
              $target.addEventListener('mouseenter',event=>{
                isHover=true;
                switchToggle.open();
              });
              $target.addEventListener('mouseleave',event=>{
                switchToggle.close();
              });
            };
          };
        };
      });
    };
  };
  _globalNavigation=()=>{
    let $parents=this.$gnav.querySelectorAll('.l-gnav-parent');
    this.$menu.addEventListener('click',event=>{
      event.preventDefault();
      let isExpanded=this.$menu.getAttribute('aria-expanded');
      let isHidden=this.$gnav.getAttribute('aria-hidden');
      if(isExpanded==='true'){
        isExpanded=false;
        isHidden=true;
        this.$body.classList.remove('body-gnav-open');
      }else{
        isExpanded=true;
        isHidden=false;
        this.$body.classList.add('body-gnav-open');
      };
      this.$menu.setAttribute('aria-expanded',isExpanded);
      this.$gnav.setAttribute('aria-hidden',isHidden);
    });
    if($parents.length){
      $parents.forEach($parent=>{
        let controls=$parent.getAttribute('aria-controls');
        let $target=document.getElementById(controls);
        if($target){
          $parent.addEventListener('click',event=>{
            event.preventDefault();
            let expanded=$parent.getAttribute('aria-expanded');
            let hidden=$target.getAttribute('aria-hidden');
            if(expanded==='false'){
              expanded=true;
              hidden=false;
            }else{
              expanded=false;
              hidden=true;
            };
            $parent.setAttribute('aria-expanded',expanded);
            $target.setAttribute('aria-hidden',hidden);
            new slideToggle($target);
          })
        };
      });
    };
    if(this.$gnavSwitchs.length){
      this.$gnavSwitchs.forEach($switch=>{
        let $trigger=$switch.querySelector('.l-gnav-switch__trigger');
        let controls=$trigger.getAttribute('aria-controls');
        let $target=document.getElementById(controls);
        if($target){
          $trigger.addEventListener('click',event=>{
            event.preventDefault();
            let expanded=$trigger.getAttribute('aria-expanded');
            let hidden=$target.getAttribute('aria-hidden');
            if(expanded==='false'){
              expanded=true;
              hidden=false;
            }else{
              expanded=false;
              hidden=true;
            };
            $trigger.setAttribute('aria-expanded',expanded);
            $target.setAttribute('aria-hidden',hidden);
            new slideToggle($target);
          })
        };
      });
    };
  };
  _scrollFixed=()=>{
    let st=SiteValues.st();
    let top=this.$sectionVisual.getBoundingClientRect().top;
    let h={
      h:SiteValues.hh(),
      visual:this.$sectionVisual.clientHeight
    };
    if(top*-1>h.visual){
      this.$body.classList.add('body-hd-fixed');
    }else{
      this.$body.classList.remove('body-hd-fixed');
      if(st>h.h){
        this.$body.classList.add('body-hd-hide');
      }else{
        this.$body.classList.remove('body-hd-hide');
      };
    };
  };
};

const $layoutHeader=document.querySelector('.l-hd');
if($layoutHeader) new layoutHeader('l-hd');


class layoutFooter {
  constructor(prefix){
    this.prefix=prefix;
    this.$body=document.body;
    this.$t=document.querySelector(`.${this.prefix}`);

    new pageScroll(`.${this.prefix}-pagetop a`);
  };
};

const $layoutFooter=document.querySelector('.l-ft');
if($layoutFooter) new layoutFooter('l-ft');

class layoutFixed {
  constructor(prefix){
    this.prefix=prefix;
    this.$t=document.querySelector(`.${this.prefix}`);
    this.$switchs=this.$t.querySelectorAll(`.${this.prefix}-switch`);
    this._switch();
  };
  _switch=()=>{
    if(this.$switchs.length){
      this.$switchs.forEach($switch=>{
        let $button=$switch.querySelector(`.${this.prefix}-switch__trigger`);
        if($button){
          let controls=$button.getAttribute('aria-controls');
          let $target=document.getElementById(controls);
          if($target){
            $button.addEventListener('click',event=>{
              event.preventDefault();
              let isExpanded=$button.getAttribute('aria-expanded');
              let isHidden=$button.getAttribute('aria-hidden');
              if(isExpanded==='true'){
                isExpanded=false;
                isHidden=true;
              }else{
                isExpanded=true;
                isHidden=false;
              };
              this.$switchs.forEach($otherSwitch=>{
                let $otherButton=$otherSwitch.querySelector(`.${this.prefix}-switch__trigger`);
                let otherControls=$otherButton.getAttribute('aria-controls');
                let $otherTarget=document.getElementById(otherControls);
                if($otherButton&&$otherTarget){
                  $otherButton.setAttribute('aria-expanded',false);
                  $otherTarget.setAttribute('aria-hidden',true);
                };
              });
              $button.setAttribute('aria-expanded',isExpanded);
              $target.setAttribute('aria-hidden',isHidden);
            });
          };
        };
      });
    };
  };
};

const $layoutFixed=document.querySelector('.l-fixed');
if($layoutFixed) new layoutFixed('l-fixed');

class toggleContent {
  constructor($trigger,$target,device){
    this.device=device;
    this.isDevice=false;
    let bool=true;

    $trigger.addEventListener('click',event=>{
      if(this.isDevice){
        event.preventDefault();
        if(bool){
          bool=false;
          $trigger.classList.add('is-active');
        }else{
          bool=true;
          $trigger.classList.remove('is-active');
        };
        new slideToggle($target);
      };
    });

    this._device();
    window.addEventListener('resize',this._device);
  };
  _device=()=>{
    this.isDevice=false;
    switch(this.device){
    case 'mobile' : if(isMobile()) this.isDevice=true; break;
    case 'desktop' : if(isDesktop()) this.isDevice=true; break;
    default : this.isDevice=true; break;
    };
  };
};

const $roastDegreeBlocks=document.querySelectorAll('.c-roast-degree__block');
if($roastDegreeBlocks.length){
  $roastDegreeBlocks.forEach($block=>{
    let $trigger=$block.querySelector('.c-roast-degree__trigger');
    let $target=$block.querySelector('.c-roast-degree__target');
    new toggleContent($trigger,$target,'mobile');
  });
};

const $productSlides=document.querySelectorAll('.c-product-slide');
if($productSlides.length){
  $productSlides.forEach($slide=>{
    let device=$slide.getAttribute('data-slide-device');
    let options={
      type:'slide',
      focus:'center',
      fixedWidth:'43.2%',
      gap:'4.26666666667%',
      padding:'4.26666666667%',
      perPage:1,
      perMove:1,
      speed:400,
      autoplay:false,
      pauseOnHover:false,
      arrows:false,
      pagination:false,
      drag:true,
      flickMaxPages:1,
      destroy:true
    };
    switch(device){
    case 'mobile' :
      options.mediaQuery='max';
      options.breakpoints={
        749:{
          destroy:false
        }
      };
      break;
    case 'desktop' :
      options.mediaQuery='min';
      options.breakpoints={
        750:{
          destroy:false
        }
      };
      break;
    default :
      options.destroy=false;
      break;
    };
    new Splide($slide,options).mount();
  });
};

const $columnSlides=document.querySelectorAll('.c-column-slide');
if($columnSlides.length){
  $columnSlides.forEach($slide=>{
    let device=$slide.getAttribute('data-slide-device');
    let options={
      type:'slide',
      focus:'center',
      trimSpace:false,
      fixedWidth:'69.3333333333%',
      gap:'1.33333333333%',
      perPage:1,
      perMove:1,
      speed:400,
      autoplay:false,
      pauseOnHover:false,
      arrows:false,
      pagination:false,
      drag:true,
      flickMaxPages:1,
      destroy:true
    };
    switch(device){
    case 'mobile' :
      options.mediaQuery='max';
      options.breakpoints={
        749:{
          destroy:false
        }
      };
      break;
    case 'desktop' :
      options.mediaQuery='min';
      options.breakpoints={
        750:{
          destroy:false
        }
      };
      break;
    default :
      options.destroy=false;
      break;
    };
    new Splide($slide,options).mount();
  });
};